(function () {
  'use strict';

  let angular = window.angular;

  Controller.$inject = ['$scope', '$rootScope', 'Customer', 'Var', 'AppUtils'];

  angular.module('app').component('createPermissionModal', {
    template:'<form name="$ctrl.updateForm" class="validate" novalidate ng-hide="ctrl.saving || ctrl.loading"><div class="modal-header"><button type="button" class="close" ng-click="ctrl.modalInstance.dismiss()"><i class="fas fa-times"></i></button> <span translate>entities.telegram.actions.addPermission</span></div><div class="modal-body paddingB0"><div ng-if="ctrl.isAdmin" class="form-group" show-errors><label class="control-label">{{\'entities.telegram.titles.userType\'| translate}}</label><ui-select ng-model="ctrl.userTypeSelected" theme="select2" ng-change="ctrl.loadUsers()"><ui-select-match placeholder="{{\'entities.telegram.titles.selectUserType\' | translate}}">{{$select.selected}}</ui-select-match><ui-select-choices repeat="userType in ctrl.userTypes | filter: $select.search">{{userType}}</ui-select-choices></ui-select><input type="text" name="userTypeSelected" class="form-control" ng-model="ctrl.userTypeSelected" style="display: none"></div><div ng-if="ctrl.userTypeSelected" class="form-group" show-errors><label class="control-label">{{\'entities.user.modelName\' | translate}}</label><ui-select ng-model="ctrl.userSelected" theme="select2" ng-change="ctrl.loadPermissionData()"><ui-select-match placeholder="{{\'entities.telegram.titles.selectUser\' | translate}}">{{$select.selected.email}}</ui-select-match><ui-select-choices repeat="user in ctrl.users | filter: $select.search">{{user.email}}</ui-select-choices></ui-select><input type="text" name="userSelected" class="form-control" ng-model="ctrl.userSelected" style="display: none"></div></div><div class="alert alert-warning no-margin text-center" ng-show="ctrl.saveError">{{ctrl.saveError}}</div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" ng-click="ctrl.modalInstance.dismiss()" translate>buttons.cancel</button> <button class="btn btn-primary" ng-click="ctrl.savePermission()" translate>buttons.save</button></div></form><div style="position: relative; height: 300px" ng-show="ctrl.saving || ctrl.loading"><spinner css-class="\'small\'" show="ctrl.saving || ctrl.loading"></spinner></div>',
    controller: Controller,
    controllerAs: 'ctrl',
    bindings: {
      modalInstance: '<',
      resolve: '<',
    },
  });

  function Controller($scope, $root, Customer, Var, utils) {
    let vm = this;

    vm.$onInit = function onInit() {
      vm.savePermission = savePermission;
      vm.loadUsers = loadUsers;
      vm.loading = true;
      vm.isAdmin = $root.isAdmin;
      //vm.isAdmin = false;
      let ids = [];
      vm.resolve.permissions.forEach((permission) => {
        ids.push(permission.vsaasUserId);
      });
      Customer.prototype$__get__managers({ id: vm.resolve.customerId }).$promise.then(
        (managersData) => {
          managersData = managersData.filter((user) => {
            return !ids.includes(user.id);
          });
          vm.managers = managersData;
          if (vm.isAdmin) {
            vm.userTypes = ['Admin', 'Manager'];
            Var.prototype$__get__admins({ id: $root.user.varId }).$promise.then((adminsData) => {
              adminsData = adminsData.filter((user) => {
                return !ids.includes(user.id);
              });
              vm.admins = adminsData;
              vm.loading = false;
              loadUsers();
            });
          } else {
            //es un manager
            vm.userTypeSelected = 'Manager';
            loadUsers();
            vm.loading = false;
          }
        }
      );
    };
    function savePermission() {
      vm.saving = true;
      Customer.prototype$__create__projects__telegramPermissions(
        { id: vm.resolve.customerId, nk: vm.resolve.projectId },
        { id: vm.userSelected.id, type: vm.userTypeSelected }
      )
        .$promise.then((res) => {
          res.email = vm.userSelected.email;
          res._id = res.id;
          res.permission;
          vm.modalInstance.close({ permission: res });
        })
        .catch((error) => {
          vm.saveError = utils.getHTTPError(error);
          vm.saving = false;
        });
    }

    function loadUsers() {
      if (vm.userTypeSelected == 'Admin') {
        vm.users = vm.admins;
      } else {
        vm.users = vm.managers;
      }
    }
  }
})();
